import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

import { actionClearSession } from '../redux/actions/PageAction';
import { goToChangePassword } from '../components/GoToPage';

import { Menu, Dropdown } from 'semantic-ui-react';
import { session } from '../components/SessionStorage';
import UserProfile from '../images/favicon/favicon.png';

import { actionLogout } from '../redux/actions/AuthenticationAction';

class Profile extends Component {
    user = session.getUserInfo();

    constructor(props) {
        super(props);

        this.props = props;
        this.state = {
            name: `${ this.user.name } ( ${ this.user.role && this.user.role.description } )`,
        };
        this.handleOptionClick = this.handleOptionClick.bind(this);
        this.handleDropDownClick = this.handleDropDownClick.bind(this);
        this.handleLogOut = this.handleLogOut.bind(this);
    }

    handleOptionClick(e, option) {
        switch (option) {
        case 'changePassword':
            this.handleChangePassword(e);
            break;
        default:
            this.handleLogOut(e);
            break;
        }
    }

    handleDropDownClick() {
        const dropdownDOM = ReactDOM.findDOMNode(this.dropdown);
        dropdownDOM && dropdownDOM.click();
    }

    handleChangePassword() {
        goToChangePassword();
    }

    handleLogOut() {
        this.props.logout();
    }

    render() {
        const { isUserEditable } = this.props;
        const { name } = this.state;

        const content = (
            <div className="profile" onClick={this.handleDropDownClick}>
                <div className="profile__item item__pic">
                    <img className="user__pic" src={UserProfile} />
                </div>
                <div className="profile__item item__name">
                    <span className="user__name">{name}</span>
                </div>

                <Dropdown
                    className="right item"
                    ref={dropdown => {
                        this.dropdown = dropdown;
                    }}>
                    <Dropdown.Menu className="user__menu">
                        {isUserEditable && (
                            <Dropdown.Item
                                onClick={e => {
                                    this.handleOptionClick(e, 'changePassword');
                                }}>
                                Change password
                            </Dropdown.Item>
                        )}
                        <Dropdown.Item
                            onClick={e => {
                                this.handleOptionClick(e, '');
                            }}>
                            Log out
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        );

        return <Menu className="profile__user">{content}</Menu>;
    }
}

const mapStateToProps = ({ user }) => {
    const { isUserEditable } = user;
    return {
        isUserEditable,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        logout: () => {
            dispatch(actionLogout());
            dispatch(actionClearSession());
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Profile);
